<template>
    <section class="container py-5">
        <div class="row justify-content-center py-5">
            <div class="col-md-5 px-5 py-2">
                <h1>Partenariat avec les plus compétents en Tunisie</h1>
            </div>
            <div class="col-md-5 px-5 py-2">
                <h6 class="font-weight-normal">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam aliquam turpis quis aliquam tristique. Etiam vel est elementum, aliquet augue sit amet, varius tellus. Phasellus id sapien tellus. Fusce non convallis arcu. Ut consectetur dui lorem, quis vestibulum orci dapibus in.</h6>
            </div>
            <div class="col-md-10 px-5 pt-5 mt-4 d-flex justify-content-center row">
                <div class="col-lg-2 p-lg-5 col-md-3 p-md-4 col-sm-4 col-6 p-3">
                    <img src="@/assets/img/partners/sassi.png" class="mw-100 h-auto"/>
                </div>
                <div class="col-lg-2 p-lg-5 col-md-3 p-md-4 col-sm-4 col-6 p-3">
                    <img src="@/assets/img/partners/taybah.png" class="mw-100 h-auto"/>
                </div>
                <div class="col-lg-2 p-lg-5 col-md-3 p-md-4 col-sm-4 col-6 p-3">
                    <img src="@/assets/img/partners/aecor.jpg" class="mw-100 h-auto"/>
                </div>
                <div class="col-lg-2 p-lg-5 col-md-3 p-md-4 col-sm-4 col-6 p-3">
                    <img src="@/assets/img/partners/marcelone.png" class="mw-100 h-auto"/>
                </div>
                <div class="col-lg-2 p-lg-5 col-md-3 p-md-4 col-sm-4 col-6 p-3">
                    <img src="@/assets/img/partners/eagle_academy.png" class="mw-100 h-auto"/>
                </div>
                <div class="col-lg-2 p-lg-5 col-md-3 p-md-4 col-sm-4 col-6 p-3">
                    <img src="@/assets/img/partners/wembley.png" class="mw-100 h-auto"/>
                </div>
                <div class="col-lg-2 p-lg-5 col-md-3 p-md-4 col-sm-4 col-6 p-3">
                    <img src="@/assets/img/partners/saheb_ettabaa.png" class="mw-100 h-auto"/>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import 'vue3-carousel/dist/carousel.css';
import { Carousel, Slide, Navigation, Pagination } from 'vue3-carousel';

export default {
  components: {
    Carousel,
    Slide,
    Navigation,
    Pagination,
  },
}
</script>